import { useSelector } from 'react-redux';
// import { useTranslation } from 'react-i18next';

import { TimerButton } from 'libs/ui';
import { AddBsk } from './bsk/add-bsk';
import { Content } from './app-actions.styled';

export const AppActions = (props) => {
  const { id, sendControlMsg } = props;
  // const { t } = useTranslation();
  const isCardDispenser = useSelector((store) => (store.equipment[id] ? !!store.equipment[id].card_dispenser : false));
  const rightControl = window.haveRight('mnemo.rack_control');

  return (
    <Content>
      {rightControl && <TimerButton title="Разблокировать оборудование" icon="unlock.svg" action={() => sendControlMsg('unblock')} timeout={10000} />}

      {isCardDispenser && window.haveRight('mnemo.add_subscriptions') && <AddBsk id={id} />}
    </Content>
  );
};
